<template>
  <div class="NoCollateralUnauthOfferCardContainer">
    <ProposedOfferCardContainer
      product-label="Sem garantia"
      v-bind="$attrs"
      :offer="offer"
      @brand-click="displayOfferDetailsModal = true"
      @offer-conditions-click="displayOfferDetailsModal = true"
      @action-forward-click="displayOfferDetailsModal = true"
    />
    <OfferDetailsModal
      v-if="displayOfferDetailsModal"
      :offer="offer"
      :is-fullscreen-mobile="true"
      product-type="Empréstimo sem garantia"
      :display="displayOfferDetailsModal"
      @close="displayOfferDetailsModal = false"
    >
      <template #actions>
        <Button type="primary" @click="selectOffer">
          Fazer login para continuar
        </Button>
      </template>
    </OfferDetailsModal>
  </div>
</template>
<script>
import Button from '@/aasgard/components/buttons/Button.vue'
import OfferDetailsModal from '@/components/commomComponents/modals/OfferDetailsModal.vue'
import ProposedOfferCardContainer from '~/containers/loans/ProposedOfferCardContainer.vue'
export default {
  name: 'NoCollateralUnauthOfferCardContainer',
  components: {
    ProposedOfferCardContainer,
    Button,
    OfferDetailsModal,
  },
  props: {
    offer: { type: Object, required: true },
  },
  data() {
    return {
      displayOfferDetailsModal: false,
    }
  },
  methods: {
    selectOffer() {
      this.$router.push({
        path: '/login',
        name: 'login',
        query: {
          nextPage: '/ofertas',
        },
      })
    },
  },
}
</script>
